import { render, staticRenderFns } from "./DataDictionaryValidation.vue?vue&type=template&id=f80d515c&scoped=true&"
import script from "./DataDictionaryValidation.vue?vue&type=script&lang=ts&"
export * from "./DataDictionaryValidation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80d515c",
  null
  
)

export default component.exports